import { merge } from "lodash"
import { useEffect } from "react"
import { useAppUI } from "../useAppUI"

export interface IUsePageSideBarLayout {
  sidebar?: {
    className?: string
    open?: boolean
    delay?: number
  }
}

const IS_OPEN_SIDEBAR_CLASSNAME = "is-open-sidebar"

const DEFAULT_OPTIONS = {
  sidebar: {
    className: IS_OPEN_SIDEBAR_CLASSNAME,
    open: true,
    delay: 250,
  },
}

export const usePageSideBarLayout = (props: IUsePageSideBarLayout) => {
  const { sidebar } = merge(DEFAULT_OPTIONS, props)
  const { sidebarState, setSidebarState } = useAppUI()

  /**
   * Effect to handle:
   * - Sidebar open/close with optional delay for consistent transitions.
   * - Adding/removing a class on <body> to adjust layout when sidebar state changes.
   */
  useEffect(() => {
    if (!sidebar || !sidebar.className) return

    const { open, delay } = sidebar

    const timer = setTimeout(() => {
      setSidebarState(open)
      document.body.classList[open ? "add" : "remove"](sidebar.className)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [sidebar, setSidebarState])

  return {
    open: sidebarState,
  }
}
